import { render } from "./ui-tags-simple-list.vue?vue&type=template&id=24185c2b&scoped=true&ts=true"
import script from "./ui-tags-simple-list.vue?vue&type=script&lang=ts"
export * from "./ui-tags-simple-list.vue?vue&type=script&lang=ts"

import "./ui-tags-simple-list.vue?vue&type=style&index=0&id=24185c2b&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24185c2b"]])

export default __exports__